import { render } from "./ClientePrecioView.vue?vue&type=template&id=5a381b94&scoped=true"
import script from "./ClientePrecioView.vue?vue&type=script&lang=js"
export * from "./ClientePrecioView.vue?vue&type=script&lang=js"

import "./ClientePrecioView.vue?vue&type=style&index=0&id=5a381b94&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a381b94"]])

export default __exports__